import { Navigate } from "react-router-dom";
import { useAuth } from "context/AuthContextProvider";
import { UserType } from "shared/types/enum";
import { hasRole } from "shared/utils/role";
import PATHS from "shared/constants/paths";

interface RequireRoleProps {
  allow: UserType[];
  children: React.ReactNode;
}

// Per-route role gate. ProtectedRoutes only checks auth (it wraps every page
// route once via a single top-level Outlet, so it can't express "this one
// route needs Manager"). Wrap a route element in RequireRole for that, e.g.
// { path: PATHS.ANALYTICS_SALES, element: <RequireRole allow={[UserType.Manager]}><SalesAnalyticsPage/></RequireRole> }
const RequireRole = ({ allow, children }: RequireRoleProps) => {
  const { state } = useAuth();
  const allowed = allow.some((role) => hasRole(state.user?.roles, role));
  return allowed ? <>{children}</> : <Navigate to={PATHS.DASHBOARD} replace />;
};

export default RequireRole;
